import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {User} from "../../user/user";
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, first, switchMap} from "rxjs/operators";
import {Store} from '@ngrx/store';
import * as fromStore from '../../store';
import {UserService} from "../../user/user.service";
import {ActivatedRoute} from "@angular/router";
import {GoogleAnalyticsService} from "../../shared/services/google-analytics/google-analytics.service";

@Component({
    selector: 'db-migration-only',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './migrate-only.component.html',
    styleUrls: ['./migrate-only.component.scss'],
    standalone: false
})
export class MigrateOnlyComponent implements OnInit {

  @Input() managerLink: string;
  @Input() newOnboarding: boolean = true;
  @Input() user: User;
  @Output() download: EventEmitter<void> = new EventEmitter<void>();

  public agencyFreelancer: boolean;
  public blankWebsite: string[] = ['Non-realistic conditions', 'Pre-optimized website templates',
    'Max 30Mb of files', 'No installed plugins'];
  public copyWebsite: string[] = ['Real performance', '90+ Mobile PageSpeed for the website',
    'All your website content', 'All your plugins active in WP'];
  public offers1: string[] = ['90+ PageSpeed score for desktop & mobile', 'Real-time backups', 'Premium security & malware protection'];
  public offers2: string[] = ['Reliable hosting with Google Cloud - 99,9% uptime', 'Data protection', 'Optimized performance'];
  public newOnboardingOffers1: string[] = ['Reliable hosting with Google Cloud: 99,9% uptime', 'Real-time backups', 'Premium security & malware protection', 'Free SSL certificates'];
  public newOnboardingOffers2: string[] = ['90+ PageSpeed score for desktop & mobile', 'Elastic scaling', 'Staging environment', '24/7 Live chat support'];
  public newOnboardingOffers3: string[] = ['Image optimizer', 'Critical CSS generation', 'Image lazy loading', 'JavaScript delay'];
  public newOnboardingOffers4: string[] = ['Server-side page caching', 'Faster dynamic page loading', 'Faster WordPress admin dashboard', 'Up-to-date PHP, MySQL, Nginx'];
  public optimizationService: string[] = ['Optimization Service'];
  public hostingService: string[] = ['Hosting'];
  public offerFirstColumn: string[];
  public offerSecondColumn: string[];
  public offerThirdColumn: string[];
  public offerFourthColumn: string[];
  public userLocalStorage: any;
  public userLocalStorage1: any;

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _route: ActivatedRoute,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _userService: UserService
  ) { }

  ngOnInit() {
    this.offerFirstColumn = this.newOnboarding ? this.newOnboardingOffers1 : this.offers1;
    this.offerSecondColumn = this.newOnboarding ? this.newOnboardingOffers2 : this.offers2;
    this.offerThirdColumn = this.newOnboardingOffers3;
    this.offerFourthColumn = this.newOnboardingOffers4;
    this.user = this.user || this._route.snapshot.data['user'];
    if (this.user && this.user.signUpFor && this.user.signUpFor.Role && this.user.signUpFor.Role.id) {
      this.agencyFreelancer = this.user.agencyOrFreelancer;
    }
    this._store.select(fromStore.getTenWebProductsLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getTenWebManagerPlugin)),
        first()
      ).subscribe(managerPlugin => {
      this.managerLink = managerPlugin && managerPlugin.downloadLink;
    });
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUserLocalStorage)),
        first()
      )
      .subscribe((userLocalStorage: any) => {
        this.userLocalStorage = userLocalStorage;
      });
  }

  public downloadPlugin() {
    this.userLocalStorage['migrateFromPage'] = 'Change Hosting';
    this._userService.setToLocal(this.userLocalStorage)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          this._store.dispatch(new fromStore.LoadUserLocalStorage());
        }
      });
    if (this.newOnboarding) {
      this.downloadManagerPluginEvent();
    }
    else {
      this.download.emit();
    }
  }
  public downloadManagerPluginEvent(): void {
    const analyticsData = {
      eventCategory: 'Onboarding',
      eventAction: 'Change Hosting',
      eventLabel: 'Download Plugin'
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }
}
